import { lastDealsProductsInitialState, LastDealsProductsState } from './last-deals-products.state';
import { LastDealsProductsActionsUnion, LastDealsProductsActionTypes } from './last-deals-products.actions';

export function lastDealsProductsReducer(
  state: LastDealsProductsState = lastDealsProductsInitialState,
  action: LastDealsProductsActionsUnion) {

  switch (action.type) {
    case LastDealsProductsActionTypes.LOAD_LAST_DEALS_PRODUCTS:
      return { ...state, loading: true };
    case LastDealsProductsActionTypes.LOAD_LAST_DEALS_PRODUCTS_SUCCESS:
      return {
        ...state,
        payload: action.payload.products,
        loading: false,
      };
    case LastDealsProductsActionTypes.LOAD_LAST_DEALS_PRODUCTS_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false
      };
    default:
      return state;
  }
}
